import './modulePreview.css'
import Patterns from "../summaryReport/subComponents/patterns";
import { panelInformation } from "../../DataFiles/panelInformation";

const ModulePreview = (props) => {
  const { roofDetail } = props;

  let panelDetail = panelInformation.find(
    (item) => item.brand === roofDetail.module
  );
  let panel = panelDetail.panelType.find(
    (item) => item.name === roofDetail.moduleType
  );

  return (
    <>
      <div id="panel-datasheet" className="panel-datasheet">
        {/* Patterns */}
        <Patterns />
        <main className="pd-body">
          <img
            className="img"
            src={panel.panelSheet1}
            alt={panelDetail.brand}
          ></img>
        </main>
      </div>
      <div id="panel-datasheet" className="panel-datasheet">
        {/* Patterns */}
        <Patterns />
        <main className="pd-body">
          <img
            className="img"
            src={panel.panelSheet2}
            alt={panelDetail.brand}
          ></img>
        </main>
      </div>
    </>
  );
};

export default ModulePreview;
